/* eslint-disable jsx-a11y/anchor-has-content*/
import * as React from 'react';
import styled from 'styled-components';
import { colors } from '../../variables';

const getColor = (props, state) => {
	if (props.white) {
		if (state === 'hover') return colors.grey.light;
		return '#fff';
	}

	if (props.digital) {
		if (state === 'hover') return colors.blue.digitalLight;
		return colors.blue.digitalDark;
	}

	if (state === 'hover') return colors.blue.brommaDark;
	return colors.blue.bromma;
};

const getDisplay = props => {
	if (props.block) return 'block';
	if (props.inlineBlock) return 'inline-block';
	return 'inline';
};

const StyledLink = ({ white, digital, underline, inlineBlock, ...rest }) => (
	<a rel="noopener noreferrer" target="_blank" {...rest} />
);

const Anchor = styled(StyledLink)`
	cursor: pointer;
	color: ${props => getColor(props)};
	text-decoration: ${props => (props.underline ? 'underline' : 'none')};
	display: ${props => getDisplay(props)};

	&:hover,
	&:focus {
		color: ${props => getColor(props, 'hover')};
	}
`;

export default Anchor;



// WEBPACK FOOTER //
// ./src/components/Common/AnchorLink/AnchorLink.js